import * as Sentry from '@sentry/react';
import _isEmpty from 'lodash/isEmpty';
import _isPlainObject from 'lodash/isPlainObject';

/**
 * @param {Error} error
 * @param {object} [extra]
 * @param {object} [tags] - `tags` are indexed/filterable in Sentry but `extra` is not.
 */
export default function logError(error, extra, tags) {
  if (process.env.REACT_APP_MODE === 'DEVELOPMENT') {
    console.log('Log Error: ', error);
  }

  const captureContext = {};
  if (_isPlainObject(extra) && !_isEmpty(extra)) {
    captureContext.extra = extra;
  }
  if (_isPlainObject(tags) && !_isEmpty(tags)) {
    captureContext.tags = tags;
  }

  if (!_isEmpty(captureContext)) {
    Sentry.captureException(error, captureContext);
  } else {
    Sentry.captureException(error);
  }
}
